import { render, staticRenderFns } from "./college.vue?vue&type=template&id=7aebb09c&scoped=true"
import script from "./college.vue?vue&type=script&lang=js"
export * from "./college.vue?vue&type=script&lang=js"
import style0 from "./college.vue?vue&type=style&index=0&id=7aebb09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aebb09c",
  null
  
)

export default component.exports